import { Modal, InputGroup, Container, Input, InputGroupAddon, InputGroupText, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import styled from "styled-components"
import React, { useEffect, useState, useRef } from "react"
import JsFileDownloader from 'js-file-downloader';
import editDocument from "../../../api/editDocument";
import getDefaultDocument from '../../../api/getDefaultDocument';
import getRecycleDocument from '../../../api/getRecycleDocument';
import getDocumentsDynamicDisplay from '../../../api/getDocumentsDynamicDisplay';
import { useDispatch, useSelector } from "react-redux";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { AiFillLeftCircle, AiFillRightCircle } from "react-icons/ai"
import pdfjs from "pdfjs-dist";
import axios from "axios";
import { showToastAction } from "../../../redux/toastSlice";
import { Button } from "react-bootstrap";
import { act } from "react";
import { Tooltip } from 'antd';
import nextIcon from '../../../assets/svg/next.svg'
import prevIcon from '../../../assets/svg/previous.svg'


export default function DocumentModal({ show, handleClose, selectedDocument, ModalType = undefined, document_status }) {
    console.log('ModalType', ModalType)
    const selectedProject = useSelector(state => state.selectedProject);
    const userState = useSelector(state => state.user)
    const dispatch = useDispatch();
    const { form_name } = useParams();
    const [image, setImage] = useState(null);
    const [pdfPageNumber, setPdfPageNumber] = useState({ currPage: 1, totalPage: 1 })
    const [decodedImage, setDecodedImage] = useState({ decoded: {}, id: '' })
    const [data, setData] = useState({});
    const [loadDoc, setLoadDoc] = useState('')
    const [selectedDoc, setSelectedDoc] = useState(null)
    const [columnsSize, setColumnsSize] = useState(null)
    const renderTaskRef = useRef(null);
    // Recuperer le form_name depuis le path ou prendre celui de selectedDocument
    const selectedFormName = form_name ? form_name : selectedDocument.form_name
    pdfjs.GlobalWorkerOptions.workerSrc = "https://d2v5g.csb.app/pdf.worker.js";


    const { isLoading, result } = useQuery(
        ["getDocumentsDynamicDisplay", selectedProject.name, selectedFormName],
        () => getDocumentsDynamicDisplay(selectedProject.name, selectedFormName, selectedDocument._id),
        {
            enabled: selectedDocument?._id ? true : false, // La requête n'est exécutée que si selectedDocument existe
            onSuccess: (data) => {
                setSelectedDoc(data?.data?.data);
                setColumnsSize(data?.data?.data?.columns_size)
            },
            onError: (err) => {
                console.log("error", err)
            }
        }
    );

    // useEffect(() => {
    //     if (data) {
    //         setSelectedDoc(data);
    //     }
    // }, [data]);


    useEffect(() => {
        setImage(null)
        setPdfPageNumber({ currPage: 1, totalPage: 1 })
    }, [show])

    useEffect(() => {
        // fetch("https://source.unsplash.com/collection/1901880").then((res) => {
        //     setImage(res.url);
        // })
        async function fetchDefaultdocument() {
            // You can await here
            try {
                if (selectedDocument) {
                    const defaultdocument = await getDefaultDocument(selectedProject.name, selectedFormName, selectedDocument._id);
                    var decodedFile = defaultdocument.data;
                    if (decodedFile?.type?.includes('image')) {
                        const url = URL.createObjectURL(decodedFile);
                        setImage(url);
                    } else if (decodedFile?.type === 'application/pdf') {
                        setDecodedImage({ decoded: decodedFile, id: 'upload_preview' })
                        renderPdfToImage(decodedFile, "upload_preview")
                    }
                }
            }
            catch (err) {
                console.log("Error", err)
                dispatch(showToastAction({ message: err.response?.data?.errorMessage ?? "Error", showToast: true }))
            }
        }
        if (!ModalType) {
            fetchDefaultdocument();
        }
    }, [show, selectedDocument])

    useEffect(() => {
        async function fetchRecycleDocument() {
            try {
                setLoadDoc('loading...')
                const recycleDocument = await getRecycleDocument(selectedProject.name, window.location.pathname.split("/")[2], selectedDocument._id);
                var decodedFile = recycleDocument.data;
                if (decodedFile?.type?.includes('image')) {
                    const url = URL.createObjectURL(decodedFile);
                    setImage(url);
                } else if (decodedFile?.type === 'application/pdf') {
                    setDecodedImage({ decoded: decodedFile, id: 'recycle_preview' })
                    renderPdfToImage(decodedFile, "recycle_preview")
                }
            }
            catch (err) {
                setLoadDoc('failed!')
            }
        }
        if (ModalType && ModalType != "") {
            fetchRecycleDocument();
        }
    }, [show, ModalType, selectedProject, selectedDocument])

    useEffect(() => {
        if (decodedImage?.decoded?.type === 'application/pdf') {
            renderPdfToImage(decodedImage?.decoded, decodedImage?.id)
        }
    }, [pdfPageNumber?.currPage])

    const renderPdfToImage = (pdf_file, ele_id) => {
        let reader = new FileReader();
        reader.onload = function (e) {
            const data = atob(e.target.result.replace(/.*base64,/, ''));
            pdfjs.getDocument({ data }).then(function (pdf) {
                setPdfPageNumber(prevState => ({ ...prevState, totalPage: pdf.numPages }));

                const renderPage = async (pageNum) => {
                    const page = await pdf.getPage(pageNum);
                    const viewport = page.getViewport({ scale: 2.0 });
                    const canvas = document.getElementById(ele_id);
                    const context = canvas.getContext('2d');
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;

                    const renderContext = {
                        canvasContext: context,
                        viewport: viewport,
                    };


                    // Cancel previous render task if it exists
                    if (renderTaskRef.current) {
                        renderTaskRef.current.cancel();
                    }

                    // Start new render task
                    renderTaskRef.current = page.render(renderContext);
                    await renderTaskRef.current.promise;
                    setLoadDoc('');
                    renderTaskRef.current = null;
                };

                renderPage(pdfPageNumber.currPage);
            });
        };
        reader.readAsDataURL(pdf_file);
    };

    if (!selectedDocument) return <></>;

    const downloadImg = () => {
        new JsFileDownloader({
            url: image,
            filename: "download.png"
        })
    }

    const updateData = (key, value) => setData((prev) => ({ ...prev, [key]: value }))

    const handleEdit = async () => {
        try {
            await editDocument(selectedProject.name, selectedFormName, selectedDocument._id, data);
            dispatch(showToastAction({ message: "Successfully updated document", showToast: true, severity: "success" }))
            cleanDataAndCloseModal();
        }
        catch (err) {
            dispatch(showToastAction({ message: err.response?.data?.errorMessage ?? "Error", showToast: true }))
        }
    }

    const imageShowHandler = (e, action) => {
        setPdfPageNumber(prevState => {
            let currentPage = prevState.currPage;
            const totalPages = prevState.totalPage;

            if (action === 'prev') {
                currentPage = currentPage === 1 ? 1 : currentPage - 1;
            } else if (action === 'next') {
                currentPage = currentPage === totalPages ? totalPages : currentPage + 1;
            }
            return { currPage: currentPage, totalPage: totalPages };
        });
    };

    const downloadDocument = () => {
        // {{url}}/uploads-recycle/recycle_{{document_id}}.pdf
        axios.get(`/uploads-recycle/recycle_${selectedDocument._id}.pdf`, { responseType: "blob" }).then((res) => {
            let type = res.data.type.split("/")
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${selectedDocument._id}.${type.at(-1)}`);
            document.body.appendChild(link);
            link.click();
        })
    }

    const cleanDataAndCloseModal = () => {
        selectedDocument = null
        setSelectedDoc(null)
        handleClose();
    }




    return (
        <Modal isOpen={show} toggle={cleanDataAndCloseModal} fullscreen={true} size="xl">
            <ModalHeader toggle={cleanDataAndCloseModal} className="py-2">Edit Document</ModalHeader>
            <ModalBody className="py-2">
                <DocumentContainer>
                    <ParsedForm
                        updateData={updateData}
                        data={selectedDoc ? selectedDoc[pdfPageNumber.currPage] : {}}
                        selectedDocument={selectedDoc}
                        userType={userState.user_type}
                        document_status={document_status}
                        pdfPageNumber={pdfPageNumber}
                        columnsSize={columnsSize}
                    />


                    {ModalType && ModalType != "" ?
                        <>
                            <ScannedContainer className="border relative-box modal_scroll" style={{ padding: '0' }}>
                                {(!image && pdfPageNumber?.currPage !== 1) &&
                                    <Tooltip title="Précédent">
                                        <div className="arrow-icon-container left-arrow-icon" onClick={(e) => imageShowHandler(e, 'prev')}>
                                            <img src={prevIcon} alt="Previous Icon" className="arrow-icon" />
                                        </div>
                                    </Tooltip>
                                }
                                <ScannedHeading>
                                    <div className="upload-doc">
                                        <h3>File </h3>
                                        {ModalType === 'recycle' && <Button size="sm" style={{ margin: '7px 12px' }} onClick={downloadDocument}>
                                            <i className="ti-download"></i>
                                        </Button>}
                                    </div>
                                </ScannedHeading>

                                <canvas className="w-100" id="recycle_preview" />
                                {/* {loadDoc !== '' && <img className="w-100 m-4" alt={`document ${loadDoc}`} id="recycle_preview" />} */}

                                {(!image && pdfPageNumber?.currPage !== pdfPageNumber?.totalPage) &&
                                    <Tooltip title="Suivant">
                                        <div className="arrow-icon-container right-arrow-icon" onClick={(e) => imageShowHandler(e, 'next')}>
                                            <img src={nextIcon} alt="Next Icon" className="arrow-icon" />
                                        </div>
                                    </Tooltip>
                                }
                            </ScannedContainer>
                        </> :
                        <>
                            <ScannedContainer className="border relative-box modal_scroll" style={{ padding: '0' }}>
                                {(!image && pdfPageNumber?.currPage !== 1) &&
                                    <Tooltip title="Précédent">
                                        <div className="arrow-icon-container left-arrow-icon" onClick={(e) => imageShowHandler(e, 'prev')}>
                                            <img src={prevIcon} alt="Previous Icon" className="arrow-icon" />
                                        </div>
                                    </Tooltip>
                                }
                                <ScannedHeading className="py-1">
                                    <div className="border-b border-gray-300 px-3 w-full">
                                        <h3 className="mb-1 text-base">Fichier source </h3>
                                    </div>

                                </ScannedHeading>
                                {!image && <canvas className="w-100" id="upload_preview" />}

                                {image && <img src={image} className="w-100" alt="document" id="preview" />}
                                {(!image && pdfPageNumber?.currPage !== pdfPageNumber?.totalPage) &&
                                    <Tooltip title="Suivant">
                                        <div className="arrow-icon-container right-arrow-icon" onClick={(e) => imageShowHandler(e, 'next')}>
                                            <img src={nextIcon} alt="Next Icon" className="arrow-icon" />
                                        </div>
                                    </Tooltip>
                                }
                            </ScannedContainer>
                        </>}
                </DocumentContainer>

                <div className="flex gap-6 w-full mt-2">
                    <div className="w-full sm:w-4/5">
                        {ModalType !== "recycle" && (
                            <div>
                                <label className="font-bold">Observations</label>
                                <textarea
                                    onChange={(e) => updateData('observations', e.target.value)}
                                    defaultValue={selectedDoc?.observations}
                                    name="observations"
                                    id="observations"
                                    className="h-20 p-2 w-full border border-[#ced4da] rounded-md focus:outline-none"
                                ></textarea>
                            </div>
                        )}
                    </div>

                    <div className="w-full sm:w-1/5 flex flex-col justify-center items-center">
                        <div className="flex flex-col w-full justify-center items-center gap-1.5">
                            {selectedDoc?.num_detected_documents && (
                                <p className="text-black text-base">Nombre de documents: <b>{selectedDoc?.num_detected_documents}</b></p>
                            )}
                            <p className="text-black text-base">Numéro de page: <b>{pdfPageNumber?.currPage} | {pdfPageNumber?.totalPage} </b></p>
                        </div>

                        <div className="mt-2.5 flex justify-center w-full gap-4">
                            {
                                (selectedDocument?.document_status !== "VALIDATED" || userState.user_type === "ADMIN" || userState.user_type === "MASTER") &&
                                <Button variant="primary" onClick={handleEdit}>Valider</Button>
                            }
                            <Button variant="secondary" onClick={cleanDataAndCloseModal}>
                                Fermer
                            </Button>
                        </div>
                    </div>
                </div>
            </ModalBody>

        </Modal>
    );
}

const ScannedHeading = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 16px;
`

const DocumentContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 48px;
    width: 100%;

    @media screen and (min-width: 1000px) {
        flex-direction: row;
    }
`

const ScannedContainer = styled.div`
    width: 100%;
    padding: 1.5rem;
`

function ParsedForm({ data, selectedDocument, updateData, userType, document_status, pdfPageNumber, columnsSize }) {
    const [mappableDocument, setMappableDocument] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [inputValues, setInputValues] = useState({});

    const immutableCols = ["document_status", "datetime_insertion", "created_by", "last_modification_date", "modified_by", "final_storage_location", "image_name", "recycle", "archive", "new_doc"];

    useEffect(() => {
        setIsLoading(true)
        // Use {} si data est null ou undefined
        let dynamicMappableDocument = Object.entries(data ?? {})
            .filter(([key, val]) => key !== "document_preprocessing" && key !== "_id" && key !== "total_pages" && key !== "observations" && key !== "mapping");

        let staticMappableDocument = Object.entries(selectedDocument ?? {})
            .filter(([key, val]) => immutableCols.includes(key));

        dynamicMappableDocument = Array.isArray(dynamicMappableDocument) ? dynamicMappableDocument : [];
        staticMappableDocument = Array.isArray(staticMappableDocument) ? staticMappableDocument : [];

        // Combinez les documents
        const combinedMappableDocument = [...dynamicMappableDocument, ...staticMappableDocument];
        setMappableDocument(combinedMappableDocument);

        // Initialise inputValues avec les valeurs de mappableDocument
        const initialInputValues = {};
        combinedMappableDocument.forEach(([key, value]) => {
            initialInputValues[key] = value;
        });
        setInputValues(initialInputValues);

        setIsLoading(false)
    }, [data, selectedDocument, pdfPageNumber.currPage]);

    const handleInputChange = (key, value) => {
        setInputValues(prevValues => ({
            ...prevValues,
            [key]: value,
        }));
        updateData(key, value);
    };

    // const firstKey = mappableDocument.find(([key, value]) => immutableCols.includes(key))

    return (
        <Container className="border modal_scroll" style={{ padding: '0' }}>

            <h3 className="fw-bolder mb-2 data-extract text-base py-1">Données extraites</h3>
            <div style={{ padding: '1rem 1rem 0.5rem' }}>
                <div className="flex flex-col items-center justify-center h-full">

                    {!isLoading && mappableDocument.length !== 0 ? mappableDocument.map(([key, value], i) => 
                    <InputGroup
                        style={{
                            marginBottom: immutableCols.includes(key) ? 5 : 10,
                            maxWidth: immutableCols.includes(key) ? '' : '',
                            // marginTop: key === firstKey[0] ? 50 : ""
                        }} key={key}>
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText
                                style={{
                                    fontSize: immutableCols.includes(key) ? "10px" : "",
                                    padding: immutableCols.includes(key) ? "2px 10px" : "",
                                    background: !immutableCols.includes(key) ? "rgb(63, 98, 116)" : "",
                                    color: !immutableCols.includes(key) ? "#fff" : "",
                                    borderColor: !immutableCols.includes(key) ? "rgb(63, 98, 116)" : "",
                                    width: !immutableCols.includes(key) ? 200 : 200,
                                    height: immutableCols.includes(key) ? 0 : '',
                                    minHeight: immutableCols.includes(key) ? 20 : ''
                                }}
                            >
                                <Tooltip title={key}>
                                    {key}
                                </Tooltip>
                            </InputGroupText>
                        </InputGroupAddon>

                        <Input
                            style={{
                                fontSize: immutableCols.includes(key) ? "10px" : "",
                                padding: immutableCols.includes(key) ? "2px 10px" : "",
                                height: immutableCols.includes(key) ? 0 : '',
                                minHeight: immutableCols.includes(key) ? 20 : '',
                            }}
                            type={columnsSize[key] === 1 ? "textarea" : "text"}
                            rows={columnsSize[key] === 1 ? 3 : undefined}
                            onChange={(e) => handleInputChange(key, e.target.value)}
                            disabled={immutableCols.includes(key) || (document_status == "VALIDATED" && userType == "CAPTURE")}
                            value={inputValues[key] || ''}
                        />
                    </InputGroup>)
                        : (!isLoading && mappableDocument.length === 0) ? <div className="flex items-center justify-center h-56">Page non identifiée.</div> : <div className="flex items-center justify-center h-56">Chargement...</div>}
                </div>
            </div>
        </Container>
    )
}

const InputGroupContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`